exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{font-family:semplicitapro,Arial;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;height:100%}html{all:initial}.wz-router{padding-top:100px}", ""]);

// exports
